import TRACKING from "Constants/campaign/civicactioncenter/tracking";

export default {
  methods: {
    openModal(modalName) {
      this.$modal.show(modalName);
    },
    closeModal(modalName) {
      this.$modal.hide(modalName);
    },
    openPopup(url, options) {
      const opts = options || {};
      const width = opts.width || 800;
      const height = opts.height || 600;
      const left = parseInt((window.width - width) / 2, 10);
      const top = parseInt((window.height - height) / 3, 10);
      const windowName = opts.windowName || `window-${Math.random()}`;

      return window.open(
        url,
        `window-${windowName}`,
        `menubar=0,location=0,status=0,width=${width},height=${height},resizable=1,left=${left},top=${top}`
      );
    },
    openTab(url) {
      return window.open(url, "_blank").focus();
    },
    trackMixpanelInteract() {
      window.mixpanel.track(TRACKING.MIXPANEL_CAC_INTERACT_EVENT_NAME);
    }
  },
  computed: {
    componentUniqueKey() {
      return `key--${this.$options.name}`;
    }
  }
};
